import React from 'react';
import clsx from 'clsx';
import styles from './CheckboxGroup.module.scss';

const CheckboxGroup = ({
  value = [],
  onChange,
  className,
  children,
}) => {
  const handleChange = (optionValue, checked) => {
    if (!onChange) return;

    if (checked) {
      onChange([...value, optionValue]);
    } else {
      onChange(value.filter(v => v !== optionValue));
    }
  };

  const items = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return child;

    const optionValue = child.props.value;
    const checked = value.includes(optionValue);

    return React.cloneElement(child, {
      checked,
      onChange: e =>
        handleChange(optionValue, e.target.checked),
    });
  });

  return (
    <div className={clsx(styles.root, className)}>
      {items}
    </div>
  );
};

export default CheckboxGroup;
